module.exports = __webpack_public_path__ + "img/heart1.a5f60185.png";